import { create } from "zustand";
import { DeliveryResponse } from "../types";
import { URL } from "../../lib/apis";
// import { user } from "../parrtial";

interface DeliveryState {
  AddOrder: (input: any) => Promise<void>;
  orderResponse: any | null;
  loadingOrder: boolean;
}

const useOrderStore = create<DeliveryState>((set) => ({
  orderResponse: null,
  loadingOrder: false,

  AddOrder: async (input: any) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loadingOrder: true });

    try {
      const response = await fetch(
        `${URL}/orders`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(input),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to add delivery address: ${response.statusText}`
        );
      }

      const data: any = await response.json();
      set({ orderResponse: data, loadingOrder: false });
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error adding delivery address:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loadingOrder: false });
    }
  },
}));

export default useOrderStore;
